import React, { useEffect } from 'react';
import anime from 'animejs';  // Import anime.js
import TextAnimation from './TextAnimation';
import Countdown from './countdown';
import videobg from '../videobg.mp4';
const HeroAnimation = () => {
  useEffect(() => {
    // متغیر برای ذخیره موقعیت اسکرول
    let lastScrollTop = 0;

    // وقتی که اسکرول در صفحه تغییر می‌کند
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY; // موقعیت اسکرول

      // اگر اسکرول به پایین حرکت کند
      if (scrollTop > lastScrollTop) {
        anime({
          targets: '.scroll-element', // هدف انیمیشن
          translateY: -180, // حرکت به سمت بالا به اندازه 20 پیکسل
          easing: 'easeOutQuad',
          duration: 500,
        });
      } else {
        // اگر اسکرول به بالا حرکت کند
        anime({
          targets: '.scroll-element', // هدف انیمیشن
          translateY: 0, // حرکت به سمت پایین به اندازه 20 پیکسل
          easing: 'easeOutQuad',
          duration: 500,
        });
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // ذخیره موقعیت جدید اسکرول
    });
  }, []);

  return (
    <>
      <div className="relative w-full h-[100vh]">
    <video
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        autoPlay
        muted
        loop
    >
        <source src={videobg} type="video/mp4" />
        Your browser does not support the video tag.
    </video>
    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black via-black/30 to-transparent opacity-100 z-10"></div>
    
    <div className='absolute inset-0 flex items-center justify-center z-20'>
        <div className="flex flex-col w-full md:p-8 scroll-element mx-auto text-center">
            <div className="flex flex-col-reverse sm:flex-row items-center justify-center text-2xl font-bold" dir='rtl'>
                <Countdown 
                    timestamp="2024-12-31T23:59:59Z" 
                    title="تا شروع ثبت نام" 
                    cstyletitle='text-sm md:text-md font-light'
                    cstylecount='text-xl md:text-4xl'
                    cstyletext='text-[8px] md:text-md'
                    cstylebg='p-1 md:p-2'
                />
            </div>
            
            <div className="mx-auto px-12 text-5xl z-10 drop-shadow-lg leading-normal text-center">
                <p className="leading-normal text-4xl sm:text-5xl md:text-6xl">چهارمین جشنواره و مسابقات کشوری فناوری‌های نوین</p>
                <p className="leading-normal text-4xl sm:text-5xl md:text-6xl">در صنعت آب و برق</p>
            </div>

            <div className="flex flex-col-reverse sm:flex-row items-center justify-center text-2xl font-bold mt-8 text-center">
                <TextAnimation id="text-place" textStyle="fanoosText text-4xl sm:text-5xl md:text-6xl text-lime-500" text="کارون کاپ 1405" />
            </div>
        </div>
    </div>
</div>
    </>
  );
};

export default HeroAnimation;
